import React, {useCallback, useEffect, useRef, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import {useParams} from "react-router-dom";
import Api from "../Api.js";
import {useDispatch, useSelector} from "react-redux";
import {accountantRequest, taskCompanyRequest, taskManagerRequest, taskRequest} from "../store/actions/task.js";
import AddTask from "../components/AddTask.js";
import Loader from "../components/BlueButton/Loader.js";
import {word} from '../word.js'
import moment from "moment";
import ic_add_24px from "../assets/img/ic_add_24px.svg";
import {Col, Row} from "react-bootstrap";
import MyImgRound from "../components/MyImgRound.js";
import {TextField} from "@mui/material";
import {useNavigate} from "react-router-dom";
import TaskLine from "../components/TaskSingleComponents/TaskLine.js";
import ChangeRecommendation from "../components/TaskSingleComponents/ChangeRecommendation.js";
import AddManToCompany from "../components/AddManToCompany.js";
import Cookies from "js-cookie";
import {REACT_APP_API_URL} from "../config.js";
import BlueButton from "../components/BlueButton/BlueButton.js";
import SuccessToast from "../components/BlueButton/SuccessToast.js";
import ErrorToast from "../components/BlueButton/ErrorToast.js";
import TaskFiles from "../components/TaskSingleComponents/TaskFiles.js";
import LittleButton from "../components/BlueButton/LittleButton.js";
import {Link} from "react-router";
import Utils from "../helpers/Utils.js";
import {toast} from "react-toastify";
import TaskCheckBlock from "../components/TaskSingleComponents/TaskCheckBlock.js";
import CustomizedRatings from "../components/TaskSingleComponents/CustomizedRatings.js";
import TaskCycle from "../components/TaskSingleComponents/TaskCycle.js";
import 'moment/locale/hy-am.js';
import IconButtonCont from "../components/TaskSingleComponents/IconButtonCont.js";
import MessageInput from "../components/TaskSingleComponents/MessageInput.js";
import TaskRelations from "../components/TaskSingleComponents/TaskRelations.js";

function TaskSingle(props) {
    const {id} = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const dayReports = useSelector((state) => state.task.duration);
    const profession = Cookies.get("profession") || localStorage.getItem("profession") || "manager"
    const userId = Cookies.get("user_id") || localStorage.getItem("user_id")
    const managerId = Cookies.get("id") || localStorage.getItem("id")
    const manager = useSelector((state) => state.manager.employee);
    const [complete, setComplete] = useState(false)
    const [changeTask, setChangeTask] = useState(false);
    const [show, setShow] = useState(false);
    const [showTaskModal, setShowTaskModal] = useState(false);
    const [showPicker, setShowPicker] = useState(false);
    const [accountant, setAccountant] = useState({});
    const [visibleMessage, setVisibleMessage] = useState(false);
    const [addNewFile, setAddNewFile] = useState(false);
    const [loading, setLoading] = useState(false);
    const [edit, setEdit] = useState(false);
    const [copy, setCopy] = useState(false);
    const [visibleFile, setVisibleFile] = useState(false);
    const [timerLoading, setTimerLoading] = useState(false);
    const [s, setS] = useState('');
    const [time, setTime] = useState('');
    const [disabled, setDisabled] = useState(false);
    const [form, setForm] = useState(null)
    const getDayReports = async () => {
        await dispatch(taskRequest({}))
    };
    const intervalRef = useRef(null); // store interval ID
    const getData = async () => {
       try {
           const {data} = await Api.getTaskSingle(id)
           if (data.parent_task_details && data.parent_task_details.id && data.parent_task_details.id !== data.id) {
               try{
                   const parent = await Api.getTaskSingle(data.parent_task_details.id)
                   setForm({...data, parent_child_tasks: parent.data.child_tasks})
               }catch (e) {
                   setForm(data)
               }

           } else {
               setForm(data)
           }
           const t = Utils.sumParentTimer(data)
           setTime(t)
           return data
       }catch (e) {
           console.log(e)

       }
    }
    useEffect(() => {
        (async () => {
            await dispatch(accountantRequest())
            await dispatch(taskManagerRequest())
            await dispatch(taskCompanyRequest())
        })();
    }, []);

    const stopInterval = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };
    const timerEnd = async (status) => {
        try {
            if (!status) setTimerLoading(true);
            const taskData = form;

            for (const timerObj of taskData.task_timer) {
                if (timerObj.end === null) {
                    await Api.changeTimerById({ task: taskData.url }, timerObj.id);
                    await dispatch(taskRequest({}));

                    await getData();
                    setDisabled(false);
                    setTimerLoading(false);
                    stopInterval(); // stop ticking
                }
            }
        }catch (e) {

        }
    };
    const startTimer = async () => {
        if(dayReports.has_ongoing_task){
            toast.info('Դուք ունեք ակտիվ թասկ')
            return
        }
        setTimerLoading(true);

        try {
            await Api.timer({ task: form?.url });
            const { data } = await getData();
            await dispatch(taskRequest({}));
            startInterval(data.task_timer, data.status); // start ticking
        } catch (error) {
            console.error("Timer error:", error);
        } finally {
            setTimerLoading(false);
        }
    };
    const startInterval = (task_timer, status) => {
        if (
            task_timer &&
            task_timer.length > 0 &&
            task_timer[task_timer.length - 1].end === null &&
            status !== "end"
        ) {
            stopInterval(); // clear existing one
            intervalRef.current = setInterval(() => {
                timerList(task_timer);
            }, 1000);
        }
    };
    const timerSum = (array) => {
        let sum = 0;
        const now = new Date();
        const formatOptions = { timeZone: "Asia/Yerevan" };

        for (const element of array) {
            let ms = 0;
            if (element.end == null) {
                const st = new Date(element.start).toLocaleString("en-US", formatOptions);
                ms = moment(now).diff(moment(st));
            } else {
                const st = new Date(element.start).toLocaleString("en-US", formatOptions);
                const end = new Date(element.end).toLocaleString("en-US", formatOptions);
                ms = moment(end).diff(moment(st));
            }
            sum += ms;
        }

        return sum;
    };
    const timerList = (list) => {
        const duration = moment.duration(timerSum(list));
        const formatted = Math.floor(duration.asHours()) + moment.utc(timerSum(list)).format(":mm:ss");
        setS(formatted);
        return formatted;
    };
    useEffect(() => {
        return () => stopInterval();
    }, []);

    useEffect(() => {
        if (form?.task_timer && form?.status !== "end") {
            startInterval(form?.task_timer, form?.status);
        }
    }, [form]);
    const addStuff = async (url, data) => {
        setChangeTask(true);
        const end_date = data.end_date
            ? moment(data.end_date).format("YYYY-MM-DD HH:mm:ss")
            : null;

        const data_post = {
            name: data.name,
            id: data.id,
            client: data.client,
            text: data.text,
            title: data.title,
            accountant: url,
            status: data.status === "new" ? "approved" : data.status,
            end_date,
        };

        try {
            await Api.patchTask(data_post, data.id);
            SuccessToast()
            setAccountant({});
            setShowPicker(false);
            setChangeTask(false);
        } catch (error) {
            ErrorToast('')
            setChangeTask(false);
        }
    };
    const changeStatusPut = useCallback(async (url, data) => {
        try {
            const startOrEnd = data.status === "process" ? "end-task" : "start-task";
            if(startOrEnd === "start-task" && dayReports.has_ongoing_task && manager.user_id !== data.manager_user_id ){
                toast.info('Դուք ունեք ակտիվ թասկ')
                return
            }
            setLoading(true);
            setDisabled(true);
            const id = data.id;
            const timerData = {task: data.url};
            Utils.changeStatus();
            await Api.editStatus(id, startOrEnd);
            const nextStatus = data.status === "process" ? "end" : "process";
            if (nextStatus !== "end") {
                if(data.status !== "end"){
                    await Api.timer(timerData);
                }
                await getData();
                await getDayReports();
                setDisabled(false);
                setTimerLoading(false);
                Utils.changeStatus();
            } else {
                if (timerEnd) {
                    await timerEnd({status: "end"}); // if passed from component
                    await getData();

                }
                setComplete(false);
                Utils.changeStatus();
            }
            setLoading(false);
        } catch (error) {
            console.error("Error updating status:", error);
            setDisabled(false);
            setTimerLoading(false);
            setLoading(false);
        }
    }, [Utils.changeStatus,getData, getDayReports, timerEnd,manager]);
    const getTaskRate = (form, isClient = false) => {
        if (!form?.ratings?.length) return null;
        const rating = form.ratings.find(r => isClient ? r.client : r.manager);
        return rating?.score ?? null;
    };
    useEffect(() => {
        (async () => {
            const data = await getData();
            timerList(data.task_timer);
            setComplete(!(profession === "manager" ||
                (profession === "accountant" && data.status === "end") ||
                (profession === "accountant" && data.accountant !== `${REACT_APP_API_URL}accountant/${localStorage.getItem("id")}/`)))

        })()
    }, [id, profession, REACT_APP_API_URL, managerId, userId])
    const taskTimer = form?.task_timer || [];
    let timer_title = form?.task_timer
    && form?.task_timer.length > 0
    && form?.task_timer[taskTimer.length - 1].end == null
        ? word.stop
        : word.start

    const timerOkay = form?.status === "process" &&
        (profession === "accountant" ||
            (profession === "manager" &&
                !form?.accountant &&
                form?.manager &&
                (form?.manager_id === +managerId || form?.accountant_user_id === +userId)))

    return (
        <Wrapper>
            <div className='recommendation-page'>
                {addNewFile && (
                    <div className="transparent-loader">
                        <Loader size={15}/>
                    </div>
                )}
                {showTaskModal && (
                    <AddTask
                        subTask="subTask"
                        show={showTaskModal}
                        onHide={() => setShowTaskModal(false)}
                        task={form}
                        getData={getData}
                    />
                )}
                {!form?<div className="transparent-loader">
                    <Loader size={15}/>
                </div>:
                <Row className='justify-content-between'>

                    <Col xs={12} sm={8}>
                        <a onClick={() => navigate(-1)} className="link-Backward-arrow">
                            <span className="icon-Backward-arrow"/>
                        </a>

                        {localStorage.getItem("profession") === "manager" ? (
                            <div className="employee-name-button">
                                <div className="employee-name" onClick={() => setShow(true)}>
                                    {!accountant.image && !form?.accountant_image ? (
                                        <div className='plus-employee'>
                                            <img src={ic_add_24px} alt="plus"/>
                                        </div>
                                    ) : (
                                        <MyImgRound image={accountant.image || form?.accountant_image}/>
                                    )}

                                    {!accountant.user && !form?.accountant_first_name ? (
                                        <span>{word.add_new_employee}</span>
                                    ) : (
                                        <span>
                                {accountant.user?.first_name || form?.accountant_first_name} <br/>
                                            {accountant.user?.last_name || form?.accountant_last_name}
                            </span>
                                    )}
                                </div>

                                <div className="timePicker-cont-change">
                                    <div className="timePicker-cont">
                                        <TextField
                                            id="datetime-local"
                                            label="Վերջնաժամկետ"
                                            type="datetime-local"
                                            onChange={form?.status !== "end" ? (e) => {
                                                setForm(prev => ({...prev, end_date: e.target.value}));
                                                setShowPicker(true)
                                            } : () => {
                                            }}
                                            value={form?.end_date || ""}
                                            InputProps={{inputProps: {min: moment(new Date()).format("YYYY-MM-DDTHH:mm")},}}
                                            sx={{width: 250}}
                                            InputLabelProps={{shrink: true}}
                                        />
                                    </div>

                                    <div className="icons-copy-edit">
                                        <div className="tool-tip-cont">
                                            <div className="tool-tip">Պատճենել</div>
                                            <i className="fas fa-copy" onClick={() => setCopy(true)}/>
                                        </div>

                                        {manager?.url && form?.creator === manager?.user?.url && (
                                            <div className="tool-tip-cont">
                                                <div className="tool-tip">Խմբագրել</div>
                                                <span onClick={() => setEdit(true)} className="icon-Compose"/>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="copy-accountant-tasks">
                                {manager?.url && form?.creator === manager?.user?.url && (
                                    <div className="tool-tip-cont">
                                        <div className="tool-tip">Խմբագրել</div>
                                        <span onClick={() => setEdit(true)} className="icon-Compose"/>
                                    </div>
                                )}

                                <div className="tool-tip-cont">
                                    <div className="tool-tip">Պատճենել</div>
                                    <i className="fas fa-copy" onClick={() => setCopy(true)}/>
                                </div>
                            </div>
                        )}

                        <div className="plus-cont" onClick={() => setShowTaskModal(true)}>
                            <span className="plus">+</span>
                            <span className="tooltiptext">Կցել ենթաառաջադրանք</span>
                        </div>
                        {(((showPicker || accountant?.url) && form?.status !== 'end') || form?.status === 'new') && (
                            <BlueButton
                                title={
                                    changeTask ? (
                                        <Loader size={15}/>
                                    ) : (
                                        word.confirmed
                                    )
                                }
                                disabled={changeTask}
                                onChangeValue={() => addStuff(accountant.url, form)}
                            />
                        )}
                        {complete && (
                            <BlueButton
                                disabled={disabled}
                                title={form?.status === "approved" ? word.start : word.complet}
                                onChangeValue={() => changeStatusPut(accountant.url, form)}
                            />

                        )}
                        {profession === "manager" && form?.status === "end" && !loading? (
                            <BlueButton
                                title={word.change_status}
                                onChangeValue={() => changeStatusPut(accountant.url, form)}
                            />
                        ):loading?<Loader type="Oval" color="#fff" height={15} width={15}/>:null}
                        {profession === "manager" &&
                        !form?.accountant &&
                        form?.status !== "end" &&
                        form?.manager &&
                        (form?.manager_user_id === +userId || form?.accountant_user_id === +userId) && (
                            <BlueButton
                                disabled={disabled}
                                title={form?.status === "approved" ? word.start : word.complet}
                                onChangeValue={() => changeStatusPut(accountant.url, form)}
                            />
                        )}
                        {timerOkay && (
                            <div>
                                <LittleButton
                                    title={
                                        timerLoading ? (
                                            <Loader type="Oval" color="#fff" height={15} width={15}/>
                                        ) : (
                                            timer_title
                                        )
                                    }
                                    onChangeValue={() =>
                                        taskTimer.length > 0 && taskTimer[taskTimer.length - 1].end == null
                                            ? timerEnd()
                                            : startTimer()
                                    }
                                />
                            </div>
                        )}
                        <div className="timer">
                            <span>Ժամանակ {s}</span>
                            {form?.child_tasks?.length > 0 && (
                                <span>Ենթաառաջադրանքների ժամանակը:
                                    {time}
                                </span>
                            )}
                        </div>
                        <Link to={`/main_employee/organization/${form?.company_id}`} className="company-name">
                            {form?.company_name}
                        </Link>

                        <div className="task-heading-file">
                            <h1>{form?.name}</h1>
                        </div>

                        <p>{form?.text}</p>

                        {profession !== "manager" && (
                            <div>
                                {form?.end_date && <p className="end-date">{word.end_date}՝</p>}
                                <p className="end-date">
                                    {form?.end_date ? moment(form?.end_date).format("LLL") : ""}
                                </p>
                            </div>
                        )}
                        <TaskCheckBlock form={form} setForm={setForm}/>

                        {form?.status === "end" && (
                            <div className="title-rate">
                                <div className="title">Մենեջեր</div>
                                <CustomizedRatings
                                    disabled={profession !== "manager"}
                                    status={form?.status}
                                    defaultValue={getTaskRate(form) || null}
                                    task={form?.url}
                                    manager={manager.url}
                                    taskManager={form?.manager}
                                    id={form?.id}
                                    getData={getData}
                                />
                            </div>
                        )}
                        {form?.status === "end" && (
                            <div className="title-rate">
                                <div className="title">Հաճախորդ</div>
                                <CustomizedRatings
                                    disabled={true}
                                    status={form?.status}
                                    defaultValue={getTaskRate(form,true) || null}
                                    task={form?.url}
                                    manager={manager.url}
                                    taskManager={form?.manager}
                                    id={form?.id}
                                    getData={getData}
                                />
                            </div>
                        )}

                        {form?.status !== 'new'?<TaskCycle data={form}/>:null}
                        <div className="">Ստեղծող- <span className="creator-name">{form?.creator_name}</span></div>
                        <div className="task-date-cont">
                                <span className='moment'>Ստղ. {form?.created_date
                                    ? moment(form?.created_date).format('LLL')
                                    : null}</span>
                            {form?.status !== "new"
                                ? <span className='moment'>Սկզ. {form?.start_task_date
                                    ? moment(form?.start_task_date).format('LLL')
                                    : null}</span>
                                : null}
                            {form?.status === "end"
                                ? <span className='moment'>Ավտ. {form?.end_task_date
                                    ? moment(form?.end_task_date).format('LLL')
                                    : null}</span>
                                : null}
                        </div>
                        <div className='line-blue'/>
                        <span className="message-heading">{word.message}</span>
                        <IconButtonCont setVisibleFile={setVisibleFile} visibleFile={visibleFile} visibleMessage={visibleMessage} setVisibleMessage={setVisibleMessage} data={form}/>
                        <MessageInput visibleMessage={visibleMessage} form={form}/>
                        <TaskRelations setFilter={setForm} data={form}/>

                    </Col>
                    <Col xs={12} sm={3}>
                        <TaskLine form={form}/>
                    </Col>
                </Row>}
                {visibleFile ? <TaskFiles open={visibleFile} setData={setForm} task={form} setOpen={setVisibleFile}
                                          show_loading={false}/> : null}
                {show ?
                    <AddManToCompany setOnly={true} data={form} setData={setForm} open={show} setAccount={setAccountant}
                                     setOpen={setShow}/> : null}
                {edit ?
                    <ChangeRecommendation show={edit} edit={edit} onHide={() => setEdit(false)} task={form}/> : null}
                {copy ?
                    <ChangeRecommendation show={copy} copy={copy} onHide={() => setCopy(false)} task={form}/> : null}
            </div>
        </Wrapper>
    );
}

export default TaskSingle;